import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.6",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M7.5 3.5h15v23L20 24.8l-2.5 1.7-2.5-1.7-2.5 1.7-2.5-1.7-2.5 1.7zM11 10h8m-8 4.5h8M11 19h4.5" }, null, -1 /* CACHED */)
  ]))]))
}
export default { render: render }